import './main.scss'
import './js/script';

import './js/modal';
import './js/ajax';
import './js/js';